import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from "@vueup/vue-quill";
import { vTooltip } from "./utils/vTooltip";
import clickToSeeCodeDirective from "./utils/clickToSeeCode";
import customPopover from "./utils/popover";
import i18n from "./i18n";
import appStateManager from "./utils/appStateManager";
import { suppressAllLogs } from "./utils/consoleHelper";

import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./assets/css/remixicon.css";
import "./assets/scss/style.scss";

// מדכא את כל קריאות הלוג בכל הסביבות - זמנית מושבת לדיבוג
//suppressAllLogs(true); // true = לשמור על console.error פעיל

const pinia = createPinia();
const app = createApp(App).use(router).use(pinia).use(i18n);
app.use(VueApexCharts);
app.component("QuillEditor", QuillEditor);
app.directive("tooltip", vTooltip);
app.directive("click-to-see-code", clickToSeeCodeDirective);
app.directive("custom-popover", customPopover);

// Initialize the app state manager once the app is mounted
app.mount("#app");
// Initialize app state manager after app is mounted
appStateManager.init();
